var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrowWhitebg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 26.739,
    height: 31.174,
    stroke: "#fff",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1221",
    "data-name": "Group 1221",
    transform: "translate(78.156 0.414) rotate(90)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 39,
    cy: 39,
    r: 39,
    transform: "translate(-0.414 0.156)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(25.802 24.12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M15.719,7.753q2.048,2.026,4.1,4.053c1.03,1.023,2.114,2,3.06,3.1a2.548,2.548,0,0,0,3.25.033,2.305,2.305,0,0,0-.074-3.212Q20.985,6.664,15.924,1.6c-.334-.334-.668-.667-1-1a2.341,2.341,0,0,0-3.1-.014C8.1,4.329,4.355,8.052.626,11.793a2.2,2.2,0,0,0,.812,3.613A2.333,2.333,0,0,0,3.9,14.841c2.242-2.275,4.512-4.523,6.772-6.781.121-.12.251-.23.49-.448v.713q0,10.374.008,20.748a2.087,2.087,0,0,0,1.5,2.008,2.239,2.239,0,0,0,2.947-2.076c.022-.271.005-.544.005-.817q.006-10.211.012-20.421c0-.027,0-.055,0-.083l.082.068",
    transform: "translate(0 0)",
    stroke: "#fff",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowWhitebg);
export default __webpack_public_path__ + "static/media/right_arrow_whitebg.ae1fc55197260cb51d314681a510ecc8.svg";
export { ForwardRef as ReactComponent };